const wordse= [
        {
          "rank": 1,
          "turkishWord": "olarak",
          "englishWord": "as"
        },
        {
          "rank": 2,
          "turkishWord": "ben",
          "englishWord": "I"
        },
        {
          "rank": 3,
          "turkishWord": "onun",
          "englishWord": "his"
        },
        {
          "rank": 4,
          "turkishWord": "bu",
          "englishWord": "that"
        },
        {
          "rank": 5,
          "turkishWord": "diye",
          "englishWord": "he"
        },
        {
          "rank": 6,
          "turkishWord": "oldu",
          "englishWord": "was"
        },
        {
          "rank": 7,
          "turkishWord": "için",
          "englishWord": "for"
        },
        {
          "rank": 8,
          "turkishWord": "üzerinde",
          "englishWord": "on"
        },
        {
          "rank": 9,
          "turkishWord": "vardır",
          "englishWord": "are"
        },
        {
          "rank": 10,
          "turkishWord": "ile",
          "englishWord": "with"
        },
        {
          "rank": 11,
          "turkishWord": "onlar",
          "englishWord": "they"
        },
        {
          "rank": 12,
          "turkishWord": "olmak",
          "englishWord": "be"
        },
        {
          "rank": 13,
          "turkishWord": "at",
          "englishWord": "at"
        },
        {
          "rank": 14,
          "turkishWord": "bir",
          "englishWord": "one"
        },
        {
          "rank": 15,
          "turkishWord": "var",
          "englishWord": "have"
        },
        {
          "rank": 16,
          "turkishWord": "Bu",
          "englishWord": "this"
        },
        {
          "rank": 17,
          "turkishWord": "dan",
          "englishWord": "from"
        },
        {
          "rank": 18,
          "turkishWord": "tarafından",
          "englishWord": "by"
        },
        {
          "rank": 19,
          "turkishWord": "sıcak",
          "englishWord": "hot"
        },
        {
          "rank": 20,
          "turkishWord": "kelime",
          "englishWord": "word"
        },
        {
          "rank": 21,
          "turkishWord": "ancak",
          "englishWord": "but"
        },
        {
          "rank": 22,
          "turkishWord": "ne",
          "englishWord": "what"
        },
        {
          "rank": 23,
          "turkishWord": "bazı",
          "englishWord": "some"
        },
        {
          "rank": 24,
          "turkishWord": "olduğunu",
          "englishWord": "is"
        },
        {
          "rank": 25,
          "turkishWord": "o",
          "englishWord": "it"
        },
        {
          "rank": 26,
          "turkishWord": "sen",
          "englishWord": "you"
        },
        {
          "rank": 27,
          "turkishWord": "veya",
          "englishWord": "or"
        },
        {
          "rank": 28,
          "turkishWord": "vardı",
          "englishWord": "had"
        },
        {
          "rank": 30,
          "turkishWord": "arasında",
          "englishWord": "of"
        },
        {
          "rank": 31,
          "turkishWord": "karşı",
          "englishWord": "to"
        },
        {
          "rank": 32,
          "turkishWord": "ve",
          "englishWord": "and"
        },
        {
          "rank": 33,
          "turkishWord": "bir",
          "englishWord": "a"
        },
        {
          "rank": 34,
          "turkishWord": "içinde",
          "englishWord": "in"
        },
        {
          "rank": 35,
          "turkishWord": "biz",
          "englishWord": "we"
        },
        {
          "rank": 36,
          "turkishWord": "can",
          "englishWord": "can"
        },
        {
          "rank": 37,
          "turkishWord": "üzerinden",
          "englishWord": "out"
        },
        {
          "rank": 38,
          "turkishWord": "diğer",
          "englishWord": "other"
        },
        {
          "rank": 39,
          "turkishWord": "vardı",
          "englishWord": "were"
        },
        {
          "rank": 40,
          "turkishWord": "hangi",
          "englishWord": "which"
        },
        {
          "rank": 42,
          "turkishWord": "onların",
          "englishWord": "their"
        },
        {
          "rank": 43,
          "turkishWord": "zaman",
          "englishWord": "time"
        },
        {
          "rank": 44,
          "turkishWord": "eğer",
          "englishWord": "if"
        },
        {
          "rank": 45,
          "turkishWord": "olacak",
          "englishWord": "will"
        },
        {
          "rank": 46,
          "turkishWord": "nasıl",
          "englishWord": "how"
        },
        {
          "rank": 47,
          "turkishWord": "dedi",
          "englishWord": "said"
        },
        {
          "rank": 48,
          "turkishWord": "bir",
          "englishWord": "an"
        },
        {
          "rank": 49,
          "turkishWord": "her",
          "englishWord": "each"
        },
        {
          "rank": 50,
          "turkishWord": "söyle",
          "englishWord": "tell"
        },
        {
          "rank": 51,
          "turkishWord": "yok",
          "englishWord": "does"
        },
        {
          "rank": 52,
          "turkishWord": "set",
          "englishWord": "set"
        },
        {
          "rank": 53,
          "turkishWord": "üç",
          "englishWord": "three"
        },
        {
          "rank": 54,
          "turkishWord": "istiyorum",
          "englishWord": "want"
        },
        {
          "rank": 55,
          "turkishWord": "hava",
          "englishWord": "air"
        },
        {
          "rank": 56,
          "turkishWord": "iyi",
          "englishWord": "well"
        },
        {
          "rank": 57,
          "turkishWord": "ayrıca",
          "englishWord": "also"
        },
        {
          "rank": 58,
          "turkishWord": "oynamak",
          "englishWord": "play"
        },
        {
          "rank": 59,
          "turkishWord": "küçük",
          "englishWord": "small"
        },
        {
          "rank": 60,
          "turkishWord": "son",
          "englishWord": "end"
        },
        {
          "rank": 61,
          "turkishWord": "koymak",
          "englishWord": "put"
        },
        {
          "rank": 62,
          "turkishWord": "ev",
          "englishWord": "home"
        },
        {
          "rank": 63,
          "turkishWord": "okumak",
          "englishWord": "read"
        },
        {
          "rank": 64,
          "turkishWord": "el",
          "englishWord": "hand"
        },
        {
          "rank": 65,
          "turkishWord": "liman",
          "englishWord": "port"
        },
        {
          "rank": 66,
          "turkishWord": "büyük",
          "englishWord": "large"
        },
        {
          "rank": 67,
          "turkishWord": "büyü",
          "englishWord": "spell"
        },
        {
          "rank": 68,
          "turkishWord": "ekleyin",
          "englishWord": "add"
        },
        {
          "rank": 69,
          "turkishWord": "hatta",
          "englishWord": "even"
        },
        {
          "rank": 70,
          "turkishWord": "arazi",
          "englishWord": "land"
        },
        {
          "rank": 71,
          "turkishWord": "burada",
          "englishWord": "here"
        },
        {
          "rank": 72,
          "turkishWord": "gerekir",
          "englishWord": "must"
        },
        {
          "rank": 73,
          "turkishWord": "büyük",
          "englishWord": "big"
        },
        {
          "rank": 74,
          "turkishWord": "yüksek",
          "englishWord": "high"
        },
        {
          "rank": 75,
          "turkishWord": "böyle",
          "englishWord": "such"
        },
        {
          "rank": 76,
          "turkishWord": "izleyin",
          "englishWord": "follow"
        },
        {
          "rank": 77,
          "turkishWord": "hareket",
          "englishWord": "act"
        },
        {
          "rank": 78,
          "turkishWord": "neden",
          "englishWord": "why"
        },
        {
          "rank": 79,
          "turkishWord": "sormak",
          "englishWord": "ask"
        },
        {
          "rank": 80,
          "turkishWord": "erkekler",
          "englishWord": "men"
        },
        {
          "rank": 81,
          "turkishWord": "değişim",
          "englishWord": "change"
        },
        {
          "rank": 82,
          "turkishWord": "gitti",
          "englishWord": "went"
        },
        {
          "rank": 83,
          "turkishWord": "ışık",
          "englishWord": "light"
        },
        {
          "rank": 84,
          "turkishWord": "tür",
          "englishWord": "kind"
        },
        {
          "rank": 85,
          "turkishWord": "kapalı",
          "englishWord": "off"
        },
        {
          "rank": 86,
          "turkishWord": "gerek",
          "englishWord": "need"
        },
        {
          "rank": 87,
          "turkishWord": "ev",
          "englishWord": "house"
        },
        {
          "rank": 88,
          "turkishWord": "resim",
          "englishWord": "picture"
        },
        {
          "rank": 89,
          "turkishWord": "denemek",
          "englishWord": "try"
        },
        {
          "rank": 90,
          "turkishWord": "bizi",
          "englishWord": "us"
        },
        {
          "rank": 91,
          "turkishWord": "tekrar",
          "englishWord": "again"
        },
        {
          "rank": 92,
          "turkishWord": "hayvan",
          "englishWord": "animal"
        },
        {
          "rank": 93,
          "turkishWord": "nokta",
          "englishWord": "point"
        },
        {
          "rank": 94,
          "turkishWord": "anne",
          "englishWord": "mother"
        },
        {
          "rank": 95,
          "turkishWord": "dünya",
          "englishWord": "world"
        },
        {
          "rank": 96,
          "turkishWord": "yakın",
          "englishWord": "near"
        },
        {
          "rank": 97,
          "turkishWord": "inşa",
          "englishWord": "build"
        },
        {
          "rank": 98,
          "turkishWord": "öz",
          "englishWord": "self"
        },
        {
          "rank": 99,
          "turkishWord": "toprak",
          "englishWord": "earth"
        },
        {
          "rank": 100,
          "turkishWord": "baba",
          "englishWord": "father"
        },
        {
          "rank": 102,
          "turkishWord": "yeni",
          "englishWord": "new"
        },
        {
          "rank": 103,
          "turkishWord": "iş",
          "englishWord": "work"
        },
        {
          "rank": 104,
          "turkishWord": "bölüm",
          "englishWord": "part"
        },
        {
          "rank": 105,
          "turkishWord": "almak",
          "englishWord": "take"
        },
        {
          "rank": 106,
          "turkishWord": "olsun",
          "englishWord": "get"
        },
        {
          "rank": 107,
          "turkishWord": "yer",
          "englishWord": "place"
        },
        {
          "rank": 108,
          "turkishWord": "yapılan",
          "englishWord": "made"
        },
        {
          "rank": 109,
          "turkishWord": "canlı",
          "englishWord": "live"
        },
        {
          "rank": 110,
          "turkishWord": "nerede",
          "englishWord": "where"
        },
        {
          "rank": 111,
          "turkishWord": "sonra",
          "englishWord": "after"
        },
        {
          "rank": 112,
          "turkishWord": "geri",
          "englishWord": "back"
        },
        {
          "rank": 113,
          "turkishWord": "küçük",
          "englishWord": "little"
        },
        {
          "rank": 114,
          "turkishWord": "sadece",
          "englishWord": "only"
        },
        {
          "rank": 115,
          "turkishWord": "yuvarlak",
          "englishWord": "round"
        },
        {
          "rank": 116,
          "turkishWord": "adam",
          "englishWord": "man"
        },
        {
          "rank": 117,
          "turkishWord": "yıl",
          "englishWord": "year"
        },
        {
          "rank": 118,
          "turkishWord": "geldi",
          "englishWord": "came"
        },
        {
          "rank": 119,
          "turkishWord": "gösterisi",
          "englishWord": "show"
        },
        {
          "rank": 120,
          "turkishWord": "her",
          "englishWord": "every"
        },
        {
          "rank": 122,
          "turkishWord": "bana",
          "englishWord": "me"
        },
        {
          "rank": 123,
          "turkishWord": "vermek",
          "englishWord": "give"
        },
        {
          "rank": 124,
          "turkishWord": "bizim",
          "englishWord": "our"
        },
        {
          "rank": 125,
          "turkishWord": "altında",
          "englishWord": "under"
        },
        {
          "rank": 126,
          "turkishWord": "adı",
          "englishWord": "name"
        },
        {
          "rank": 127,
          "turkishWord": "çok",
          "englishWord": "very"
        },
        {
          "rank": 128,
          "turkishWord": "ile",
          "englishWord": "through"
        },
        {
          "rank": 129,
          "turkishWord": "sadece",
          "englishWord": "just"
        },
        {
          "rank": 130,
          "turkishWord": "formu",
          "englishWord": "form"
        },
        {
          "rank": 131,
          "turkishWord": "cümle",
          "englishWord": "sentence"
        },
        {
          "rank": 132,
          "turkishWord": "büyük",
          "englishWord": "great"
        },
        {
          "rank": 133,
          "turkishWord": "düşünmek",
          "englishWord": "think"
        },
        {
          "rank": 134,
          "turkishWord": "demek",
          "englishWord": "say"
        },
        {
          "rank": 135,
          "turkishWord": "yardım",
          "englishWord": "help"
        },
        {
          "rank": 136,
          "turkishWord": "düşük",
          "englishWord": "low"
        },
        {
          "rank": 137,
          "turkishWord": "hat",
          "englishWord": "line"
        },
        {
          "rank": 138,
          "turkishWord": "farklı",
          "englishWord": "differ"
        },
        {
          "rank": 139,
          "turkishWord": "dönüş",
          "englishWord": "turn"
        },
        {
          "rank": 140,
          "turkishWord": "neden",
          "englishWord": "cause"
        },
        {
          "rank": 141,
          "turkishWord": "çok",
          "englishWord": "much"
        },
        {
          "rank": 142,
          "turkishWord": "Yani",
          "englishWord": "mean"
        },
        {
          "rank": 143,
          "turkishWord": "önce",
          "englishWord": "before"
        },
        {
          "rank": 144,
          "turkishWord": "hareket",
          "englishWord": "move"
        },
        {
          "rank": 145,
          "turkishWord": "sağ",
          "englishWord": "right"
        },
        {
          "rank": 146,
          "turkishWord": "çocuk",
          "englishWord": "boy"
        },
        {
          "rank": 147,
          "turkishWord": "eski",
          "englishWord": "old"
        },
        {
          "rank": 148,
          "turkishWord": "çok",
          "englishWord": "too"
        },
        {
          "rank": 149,
          "turkishWord": "aynı",
          "englishWord": "same"
        },
        {
          "rank": 150,
          "turkishWord": "diye",
          "englishWord": "she"
        },
        {
          "rank": 151,
          "turkishWord": "tüm",
          "englishWord": "all"
        },
        {
          "rank": 152,
          "turkishWord": "orada",
          "englishWord": "there"
        },
        {
          "rank": 153,
          "turkishWord": "zaman",
          "englishWord": "when"
        },
        {
          "rank": 154,
          "turkishWord": "yukarı",
          "englishWord": "up"
        },
        {
          "rank": 155,
          "turkishWord": "Kullanım",
          "englishWord": "use"
        },
        {
          "rank": 156,
          "turkishWord": "senin",
          "englishWord": "your"
        },
        {
          "rank": 157,
          "turkishWord": "yol",
          "englishWord": "way"
        },
        {
          "rank": 158,
          "turkishWord": "hakkında",
          "englishWord": "about"
        },
        {
          "rank": 159,
          "turkishWord": "birçok",
          "englishWord": "many"
        },
        {
          "rank": 161,
          "turkishWord": "onları",
          "englishWord": "them"
        },
        {
          "rank": 162,
          "turkishWord": "yazmak",
          "englishWord": "write"
        },
        {
          "rank": 164,
          "turkishWord": "gibi",
          "englishWord": "like"
        },
        {
          "rank": 166,
          "turkishWord": "bu",
          "englishWord": "these"
        },
        {
          "rank": 167,
          "turkishWord": "onu",
          "englishWord": "her"
        },
        {
          "rank": 168,
          "turkishWord": "uzun",
          "englishWord": "long"
        },
        {
          "rank": 169,
          "turkishWord": "yapmak",
          "englishWord": "make"
        },
        {
          "rank": 170,
          "turkishWord": "şey",
          "englishWord": "thing"
        },
        {
          "rank": 171,
          "turkishWord": "görmek",
          "englishWord": "see"
        },
        {
          "rank": 172,
          "turkishWord": "onu",
          "englishWord": "him"
        },
        {
          "rank": 173,
          "turkishWord": "iki",
          "englishWord": "two"
        },
        {
          "rank": 174,
          "turkishWord": "var",
          "englishWord": "has"
        },
        {
          "rank": 175,
          "turkishWord": "bak",
          "englishWord": "look"
        },
        {
          "rank": 176,
          "turkishWord": "fazla",
          "englishWord": "more"
        },
        {
          "rank": 177,
          "turkishWord": "gün",
          "englishWord": "day"
        },
        {
          "rank": 178,
          "turkishWord": "olabilir",
          "englishWord": "could"
        },
        {
          "rank": 179,
          "turkishWord": "gitmek",
          "englishWord": "go"
        },
        {
          "rank": 180,
          "turkishWord": "gel",
          "englishWord": "come"
        },
        {
          "rank": 181,
          "turkishWord": "yaptım",
          "englishWord": "did"
        },
        {
          "rank": 182,
          "turkishWord": "numarası",
          "englishWord": "number"
        },
        {
          "rank": 183,
          "turkishWord": "ses",
          "englishWord": "sound"
        },
        {
          "rank": 184,
          "turkishWord": "hayır",
          "englishWord": "no"
        },
        {
          "rank": 185,
          "turkishWord": "en",
          "englishWord": "most"
        },
        {
          "rank": 186,
          "turkishWord": "insanlar",
          "englishWord": "people"
        },
        {
          "rank": 187,
          "turkishWord": "benim",
          "englishWord": "my"
        },
        {
          "rank": 188,
          "turkishWord": "üzerinde",
          "englishWord": "over"
        },
        {
          "rank": 189,
          "turkishWord": "bilmek",
          "englishWord": "know"
        },
        {
          "rank": 190,
          "turkishWord": "su",
          "englishWord": "water"
        },
        {
          "rank": 191,
          "turkishWord": "daha",
          "englishWord": "than"
        },
        {
          "rank": 192,
          "turkishWord": "çağrı",
          "englishWord": "call"
        },
        {
          "rank": 193,
          "turkishWord": "ilk",
          "englishWord": "first"
        },
        {
          "rank": 194,
          "turkishWord": "kim",
          "englishWord": "who"
        },
        {
          "rank": 196,
          "turkishWord": "aşağı",
          "englishWord": "down"
        },
        {
          "rank": 197,
          "turkishWord": "yan",
          "englishWord": "side"
        },
        {
          "rank": 198,
          "turkishWord": "oldu",
          "englishWord": "been"
        },
        {
          "rank": 199,
          "turkishWord": "Şimdi",
          "englishWord": "now"
        },
        {
          "rank": 200,
          "turkishWord": "bulmak",
          "englishWord": "find"
        },
        {
          "rank": 201,
          "turkishWord": "kafa",
          "englishWord": "head"
        },
        {
          "rank": 202,
          "turkishWord": "standı",
          "englishWord": "stand"
        },
        {
          "rank": 203,
          "turkishWord": "kendi",
          "englishWord": "own"
        },
        {
          "rank": 204,
          "turkishWord": "sayfa",
          "englishWord": "page"
        },
        {
          "rank": 205,
          "turkishWord": "gerekir",
          "englishWord": "should"
        },
        {
          "rank": 206,
          "turkishWord": "ülke",
          "englishWord": "country"
        },
        {
          "rank": 207,
          "turkishWord": "bulundu",
          "englishWord": "found"
        },
        {
          "rank": 208,
          "turkishWord": "cevap",
          "englishWord": "answer"
        },
        {
          "rank": 209,
          "turkishWord": "okul",
          "englishWord": "school"
        },
        {
          "rank": 210,
          "turkishWord": "büyümek",
          "englishWord": "grow"
        },
        {
          "rank": 211,
          "turkishWord": "çalışma",
          "englishWord": "study"
        },
        {
          "rank": 212,
          "turkishWord": "hala",
          "englishWord": "still"
        },
        {
          "rank": 213,
          "turkishWord": "öğrenmek",
          "englishWord": "learn"
        },
        {
          "rank": 214,
          "turkishWord": "bitki",
          "englishWord": "plant"
        },
        {
          "rank": 215,
          "turkishWord": "kapak",
          "englishWord": "cover"
        },
        {
          "rank": 216,
          "turkishWord": "gıda",
          "englishWord": "food"
        },
        {
          "rank": 217,
          "turkishWord": "güneş",
          "englishWord": "sun"
        },
        {
          "rank": 218,
          "turkishWord": "dört",
          "englishWord": "four"
        },
        {
          "rank": 219,
          "turkishWord": "arasında",
          "englishWord": "between"
        },
        {
          "rank": 220,
          "turkishWord": "devlet",
          "englishWord": "state"
        },
        {
          "rank": 221,
          "turkishWord": "tutmak",
          "englishWord": "keep"
        },
        {
          "rank": 222,
          "turkishWord": "göz",
          "englishWord": "eye"
        },
        {
          "rank": 223,
          "turkishWord": "asla",
          "englishWord": "never"
        },
        {
          "rank": 224,
          "turkishWord": "son",
          "englishWord": "last"
        },
        {
          "rank": 226,
          "turkishWord": "düşünce",
          "englishWord": "thought"
        },
        {
          "rank": 227,
          "turkishWord": "Şehir",
          "englishWord": "city"
        },
        {
          "rank": 228,
          "turkishWord": "ağaç",
          "englishWord": "tree"
        },
        {
          "rank": 229,
          "turkishWord": "çapraz",
          "englishWord": "cross"
        },
        {
          "rank": 230,
          "turkishWord": "çiftlik",
          "englishWord": "farm"
        },
        {
          "rank": 231,
          "turkishWord": "sert",
          "englishWord": "hard"
        },
        {
          "rank": 232,
          "turkishWord": "başlangıç",
          "englishWord": "start"
        },
        {
          "rank": 233,
          "turkishWord": "olabilir",
          "englishWord": "might"
        },
        {
          "rank": 234,
          "turkishWord": "hikaye",
          "englishWord": "story"
        },
        {
          "rank": 235,
          "turkishWord": "testere",
          "englishWord": "saw"
        },
        {
          "rank": 236,
          "turkishWord": "kadar",
          "englishWord": "far"
        },
        {
          "rank": 237,
          "turkishWord": "deniz",
          "englishWord": "sea"
        },
        {
          "rank": 238,
          "turkishWord": "çizmek",
          "englishWord": "draw"
        },
        {
          "rank": 239,
          "turkishWord": "sol",
          "englishWord": "left"
        },
        {
          "rank": 240,
          "turkishWord": "geç",
          "englishWord": "late"
        },
        {
          "rank": 242,
          "turkishWord": "yapamaz",
          "englishWord": "don’t"
        },
        {
          "rank": 243,
          "turkishWord": "süre",
          "englishWord": "while"
        },
        {
          "rank": 244,
          "turkishWord": "basın",
          "englishWord": "press"
        },
        {
          "rank": 245,
          "turkishWord": "yakın",
          "englishWord": "close"
        },
        {
          "rank": 246,
          "turkishWord": "gece",
          "englishWord": "night"
        },
        {
          "rank": 247,
          "turkishWord": "gerçek",
          "englishWord": "real"
        },
        {
          "rank": 248,
          "turkishWord": "hayat",
          "englishWord": "life"
        },
        {
          "rank": 249,
          "turkishWord": "az",
          "englishWord": "few"
        },
        {
          "rank": 250,
          "turkishWord": "kuzey",
          "englishWord": "north"
        },
        {
          "rank": 251,
          "turkishWord": "kitap",
          "englishWord": "book"
        },
        {
          "rank": 252,
          "turkishWord": "taşımak",
          "englishWord": "carry"
        },
        {
          "rank": 253,
          "turkishWord": "aldı",
          "englishWord": "took"
        },
        {
          "rank": 254,
          "turkishWord": "bilim",
          "englishWord": "science"
        },
        {
          "rank": 255,
          "turkishWord": "yemek",
          "englishWord": "eat"
        },
        {
          "rank": 256,
          "turkishWord": "oda",
          "englishWord": "room"
        },
        {
          "rank": 257,
          "turkishWord": "arkadaşı",
          "englishWord": "friend"
        },
        {
          "rank": 258,
          "turkishWord": "başladı",
          "englishWord": "began"
        },
        {
          "rank": 259,
          "turkishWord": "fikir",
          "englishWord": "idea"
        },
        {
          "rank": 260,
          "turkishWord": "balık",
          "englishWord": "fish"
        },
        {
          "rank": 261,
          "turkishWord": "dağ",
          "englishWord": "mountain"
        },
        {
          "rank": 262,
          "turkishWord": "dur",
          "englishWord": "stop"
        },
        {
          "rank": 264,
          "turkishWord": "baz",
          "englishWord": "base"
        },
        {
          "rank": 265,
          "turkishWord": "duymak",
          "englishWord": "hear"
        },
        {
          "rank": 266,
          "turkishWord": "at",
          "englishWord": "horse"
        },
        {
          "rank": 267,
          "turkishWord": "kesim",
          "englishWord": "cut"
        },
        {
          "rank": 268,
          "turkishWord": "emin",
          "englishWord": "sure"
        },
        {
          "rank": 269,
          "turkishWord": "izle",
          "englishWord": "watch"
        },
        {
          "rank": 270,
          "turkishWord": "renk",
          "englishWord": "color"
        },
        {
          "rank": 271,
          "turkishWord": "yüz",
          "englishWord": "face"
        },
        {
          "rank": 272,
          "turkishWord": "ahşap",
          "englishWord": "wood"
        },
        {
          "rank": 273,
          "turkishWord": "ana",
          "englishWord": "main"
        },
        {
          "rank": 274,
          "turkishWord": "açık",
          "englishWord": "open"
        },
        {
          "rank": 275,
          "turkishWord": "görünmek",
          "englishWord": "seem"
        },
        {
          "rank": 276,
          "turkishWord": "birlikte",
          "englishWord": "together"
        },
        {
          "rank": 277,
          "turkishWord": "sonraki",
          "englishWord": "next"
        },
        {
          "rank": 278,
          "turkishWord": "beyaz",
          "englishWord": "white"
        },
        {
          "rank": 279,
          "turkishWord": "çocuk",
          "englishWord": "children"
        },
        {
          "rank": 280,
          "turkishWord": "başla",
          "englishWord": "begin"
        },
        {
          "rank": 281,
          "turkishWord": "var",
          "englishWord": "got"
        },
        {
          "rank": 282,
          "turkishWord": "yürümek",
          "englishWord": "walk"
        },
        {
          "rank": 283,
          "turkishWord": "örnek",
          "englishWord": "example"
        },
        {
          "rank": 284,
          "turkishWord": "kolaylığı",
          "englishWord": "ease"
        },
        {
          "rank": 285,
          "turkishWord": "kağıt",
          "englishWord": "paper"
        },
        {
          "rank": 286,
          "turkishWord": "grup",
          "englishWord": "group"
        },
        {
          "rank": 288,
          "turkishWord": "müzik",
          "englishWord": "music"
        },
        {
          "rank": 289,
          "turkishWord": "bu",
          "englishWord": "those"
        },
        {
          "rank": 290,
          "turkishWord": "herikiside",
          "englishWord": "both"
        },
        {
          "rank": 291,
          "turkishWord": "işareti",
          "englishWord": "mark"
        },
        {
          "rank": 292,
          "turkishWord": "sıksık",
          "englishWord": "often"
        },
        {
          "rank": 293,
          "turkishWord": "mektup",
          "englishWord": "letter"
        },
        {
          "rank": 294,
          "turkishWord": "kadar",
          "englishWord": "until"
        },
        {
          "rank": 295,
          "turkishWord": "kilometre",
          "englishWord": "mile"
        },
        {
          "rank": 296,
          "turkishWord": "nehir",
          "englishWord": "river"
        },
        {
          "rank": 297,
          "turkishWord": "araba",
          "englishWord": "car"
        },
        {
          "rank": 298,
          "turkishWord": "ayaklar",
          "englishWord": "feet"
        },
        {
          "rank": 299,
          "turkishWord": "bakım",
          "englishWord": "care"
        },
        {
          "rank": 300,
          "turkishWord": "ikinci",
          "englishWord": "second"
        },
        {
          "rank": 301,
          "turkishWord": "yeterli",
          "englishWord": "enough"
        },
        {
          "rank": 302,
          "turkishWord": "düz",
          "englishWord": "plain"
        },
        {
          "rank": 303,
          "turkishWord": "kız",
          "englishWord": "girl"
        },
        {
          "rank": 304,
          "turkishWord": "olağan",
          "englishWord": "usual"
        },
        {
          "rank": 305,
          "turkishWord": "genç",
          "englishWord": "young"
        },
        {
          "rank": 306,
          "turkishWord": "hazır",
          "englishWord": "ready"
        },
        {
          "rank": 307,
          "turkishWord": "yukarıdaki",
          "englishWord": "above"
        },
        {
          "rank": 308,
          "turkishWord": "hiç",
          "englishWord": "ever"
        },
        {
          "rank": 309,
          "turkishWord": "kırmızı",
          "englishWord": "red"
        },
        {
          "rank": 310,
          "turkishWord": "listesi",
          "englishWord": "list"
        },
        {
          "rank": 311,
          "turkishWord": "olsa",
          "englishWord": "though"
        },
        {
          "rank": 312,
          "turkishWord": "hissetmek",
          "englishWord": "feel"
        },
        {
          "rank": 313,
          "turkishWord": "tartışma",
          "englishWord": "talk"
        },
        {
          "rank": 314,
          "turkishWord": "kuş",
          "englishWord": "bird"
        },
        {
          "rank": 315,
          "turkishWord": "yakında",
          "englishWord": "soon"
        },
        {
          "rank": 316,
          "turkishWord": "vücut",
          "englishWord": "body"
        },
        {
          "rank": 317,
          "turkishWord": "köpek",
          "englishWord": "dog"
        },
        {
          "rank": 318,
          "turkishWord": "aile",
          "englishWord": "family"
        },
        {
          "rank": 319,
          "turkishWord": "doğrudan",
          "englishWord": "direct"
        },
        {
          "rank": 320,
          "turkishWord": "poz",
          "englishWord": "pose"
        },
        {
          "rank": 321,
          "turkishWord": "bırakın",
          "englishWord": "leave"
        },
        {
          "rank": 322,
          "turkishWord": "şarkı",
          "englishWord": "song"
        },
        {
          "rank": 323,
          "turkishWord": "ölçmek",
          "englishWord": "measure"
        },
        {
          "rank": 324,
          "turkishWord": "kapı",
          "englishWord": "door"
        },
        {
          "rank": 325,
          "turkishWord": "ürün",
          "englishWord": "product"
        },
        {
          "rank": 326,
          "turkishWord": "siyah",
          "englishWord": "black"
        },
        {
          "rank": 327,
          "turkishWord": "kısa",
          "englishWord": "short"
        },
        {
          "rank": 328,
          "turkishWord": "rakam",
          "englishWord": "numeral"
        },
        {
          "rank": 329,
          "turkishWord": "sınıf",
          "englishWord": "class"
        },
        {
          "rank": 330,
          "turkishWord": "rüzgar",
          "englishWord": "wind"
        },
        {
          "rank": 331,
          "turkishWord": "soru",
          "englishWord": "question"
        },
        {
          "rank": 332,
          "turkishWord": "olur",
          "englishWord": "happen"
        },
        {
          "rank": 333,
          "turkishWord": "komple",
          "englishWord": "complete"
        },
        {
          "rank": 334,
          "turkishWord": "gemi",
          "englishWord": "ship"
        },
        {
          "rank": 335,
          "turkishWord": "alan",
          "englishWord": "area"
        },
        {
          "rank": 336,
          "turkishWord": "yarım",
          "englishWord": "half"
        },
        {
          "rank": 337,
          "turkishWord": "kaya",
          "englishWord": "rock"
        },
        {
          "rank": 338,
          "turkishWord": "sipariş",
          "englishWord": "order"
        },
        {
          "rank": 339,
          "turkishWord": "yangın",
          "englishWord": "fire"
        },
        {
          "rank": 340,
          "turkishWord": "güney",
          "englishWord": "south"
        },
        {
          "rank": 341,
          "turkishWord": "sorun",
          "englishWord": "problem"
        },
        {
          "rank": 342,
          "turkishWord": "parça",
          "englishWord": "piece"
        },
        {
          "rank": 343,
          "turkishWord": "söyledi",
          "englishWord": "told"
        },
        {
          "rank": 344,
          "turkishWord": "biliyordu",
          "englishWord": "knew"
        },
        {
          "rank": 345,
          "turkishWord": "geçmek",
          "englishWord": "pass"
        },
        {
          "rank": 346,
          "turkishWord": "beri",
          "englishWord": "since"
        },
        {
          "rank": 347,
          "turkishWord": "üst",
          "englishWord": "top"
        },
        {
          "rank": 348,
          "turkishWord": "bütün",
          "englishWord": "whole"
        },
        {
          "rank": 349,
          "turkishWord": "kral",
          "englishWord": "king"
        },
        {
          "rank": 350,
          "turkishWord": "sokak",
          "englishWord": "street"
        },
        {
          "rank": 352,
          "turkishWord": "çarpmak",
          "englishWord": "multiply"
        },
        {
          "rank": 354,
          "turkishWord": "ders",
          "englishWord": "course"
        },
        {
          "rank": 355,
          "turkishWord": "kalmak",
          "englishWord": "stay"
        },
        {
          "rank": 356,
          "turkishWord": "tekerlek",
          "englishWord": "wheel"
        },
        {
          "rank": 357,
          "turkishWord": "tam",
          "englishWord": "full"
        },
        {
          "rank": 358,
          "turkishWord": "kuvvet",
          "englishWord": "force"
        },
        {
          "rank": 359,
          "turkishWord": "mavi",
          "englishWord": "blue"
        },
        {
          "rank": 360,
          "turkishWord": "nesne",
          "englishWord": "object"
        },
        {
          "rank": 362,
          "turkishWord": "yüzey",
          "englishWord": "surface"
        },
        {
          "rank": 363,
          "turkishWord": "derin",
          "englishWord": "deep"
        },
        {
          "rank": 364,
          "turkishWord": "ay",
          "englishWord": "moon"
        },
        {
          "rank": 365,
          "turkishWord": "ada",
          "englishWord": "island"
        },
        {
          "rank": 366,
          "turkishWord": "ayak",
          "englishWord": "foot"
        },
        {
          "rank": 367,
          "turkishWord": "sistem",
          "englishWord": "system"
        },
        {
          "rank": 368,
          "turkishWord": "meşgul",
          "englishWord": "busy"
        },
        {
          "rank": 369,
          "turkishWord": "Test",
          "englishWord": "test"
        },
        {
          "rank": 370,
          "turkishWord": "kayıt",
          "englishWord": "record"
        },
        {
          "rank": 371,
          "turkishWord": "tekne",
          "englishWord": "boat"
        },
        {
          "rank": 372,
          "turkishWord": "ortak",
          "englishWord": "common"
        },
        {
          "rank": 373,
          "turkishWord": "altın",
          "englishWord": "gold"
        },
        {
          "rank": 374,
          "turkishWord": "mümkün",
          "englishWord": "possible"
        },
        {
          "rank": 375,
          "turkishWord": "düzlem",
          "englishWord": "plane"
        },
        {
          "rank": 377,
          "turkishWord": "kuru",
          "englishWord": "dry"
        },
        {
          "rank": 378,
          "turkishWord": "acaba",
          "englishWord": "wonder"
        },
        {
          "rank": 379,
          "turkishWord": "gülmek",
          "englishWord": "laugh"
        },
        {
          "rank": 380,
          "turkishWord": "bin",
          "englishWord": "thousand"
        },
        {
          "rank": 381,
          "turkishWord": "önce",
          "englishWord": "ago"
        },
        {
          "rank": 382,
          "turkishWord": "koştu",
          "englishWord": "ran"
        },
        {
          "rank": 383,
          "turkishWord": "kontrol",
          "englishWord": "check"
        },
        {
          "rank": 384,
          "turkishWord": "oyunu",
          "englishWord": "game"
        },
        {
          "rank": 385,
          "turkishWord": "şekil",
          "englishWord": "shape"
        },
        {
          "rank": 386,
          "turkishWord": "eşit",
          "englishWord": "equate"
        },
        {
          "rank": 387,
          "turkishWord": "sıcak",
          "englishWord": "hot"
        },
        {
          "rank": 388,
          "turkishWord": "özledim",
          "englishWord": "miss"
        },
        {
          "rank": 389,
          "turkishWord": "getirdi",
          "englishWord": "brought"
        },
        {
          "rank": 390,
          "turkishWord": "ısı",
          "englishWord": "heat"
        },
        {
          "rank": 391,
          "turkishWord": "kar",
          "englishWord": "snow"
        },
        {
          "rank": 392,
          "turkishWord": "lastik",
          "englishWord": "tire"
        },
        {
          "rank": 393,
          "turkishWord": "getirmek",
          "englishWord": "bring"
        },
        {
          "rank": 394,
          "turkishWord": "evet",
          "englishWord": "yes"
        },
        {
          "rank": 395,
          "turkishWord": "uzak",
          "englishWord": "distant"
        },
        {
          "rank": 396,
          "turkishWord": "doldurun",
          "englishWord": "fill"
        },
        {
          "rank": 397,
          "turkishWord": "doğu",
          "englishWord": "east"
        },
        {
          "rank": 398,
          "turkishWord": "boya",
          "englishWord": "paint"
        },
        {
          "rank": 399,
          "turkishWord": "dil",
          "englishWord": "language"
        },
        {
          "rank": 400,
          "turkishWord": "arasında",
          "englishWord": "among"
        },
        {
          "rank": 401,
          "turkishWord": "ünitesi",
          "englishWord": "unit"
        },
        {
          "rank": 402,
          "turkishWord": "güç",
          "englishWord": "power"
        },
        {
          "rank": 403,
          "turkishWord": "kasaba",
          "englishWord": "town"
        },
        {
          "rank": 404,
          "turkishWord": "ince",
          "englishWord": "fine"
        },
        {
          "rank": 405,
          "turkishWord": "belirli",
          "englishWord": "certain"
        },
        {
          "rank": 406,
          "turkishWord": "uçmak",
          "englishWord": "fly"
        },
        {
          "rank": 407,
          "turkishWord": "düşmek",
          "englishWord": "fall"
        },
        {
          "rank": 408,
          "turkishWord": "kurşun",
          "englishWord": "lead"
        },
        {
          "rank": 409,
          "turkishWord": "ağlamak",
          "englishWord": "cry"
        },
        {
          "rank": 410,
          "turkishWord": "karanlık",
          "englishWord": "dark"
        },
        {
          "rank": 411,
          "turkishWord": "makine",
          "englishWord": "machine"
        },
        {
          "rank": 412,
          "turkishWord": "notu",
          "englishWord": "note"
        },
        {
          "rank": 413,
          "turkishWord": "bekleyin",
          "englishWord": "wait"
        },
        {
          "rank": 414,
          "turkishWord": "planı",
          "englishWord": "plan"
        },
        {
          "rank": 415,
          "turkishWord": "rakam",
          "englishWord": "figure"
        },
        {
          "rank": 416,
          "turkishWord": "yıldız",
          "englishWord": "star"
        },
        {
          "rank": 417,
          "turkishWord": "kutu",
          "englishWord": "box"
        },
        {
          "rank": 419,
          "turkishWord": "alan",
          "englishWord": "field"
        },
        {
          "rank": 420,
          "turkishWord": "gerisi",
          "englishWord": "rest"
        },
        {
          "rank": 421,
          "turkishWord": "doğru",
          "englishWord": "correct"
        },
        {
          "rank": 422,
          "turkishWord": "yetenekli",
          "englishWord": "able"
        },
        {
          "rank": 423,
          "turkishWord": "kiloluk",
          "englishWord": "pound"
        },
        {
          "rank": 424,
          "turkishWord": "bitti",
          "englishWord": "done"
        },
        {
          "rank": 425,
          "turkishWord": "güzellik",
          "englishWord": "beauty"
        },
        {
          "rank": 426,
          "turkishWord": "sürücü",
          "englishWord": "drive"
        },
        {
          "rank": 427,
          "turkishWord": "durdu",
          "englishWord": "stood"
        },
        {
          "rank": 428,
          "turkishWord": "içeren",
          "englishWord": "contain"
        },
        {
          "rank": 429,
          "turkishWord": "ön",
          "englishWord": "front"
        },
        {
          "rank": 430,
          "turkishWord": "öğretmek",
          "englishWord": "teach"
        },
        {
          "rank": 431,
          "turkishWord": "hafta",
          "englishWord": "week"
        },
        {
          "rank": 432,
          "turkishWord": "nihai",
          "englishWord": "final"
        },
        {
          "rank": 433,
          "turkishWord": "verdi",
          "englishWord": "gave"
        },
        {
          "rank": 434,
          "turkishWord": "yeşil",
          "englishWord": "green"
        },
        {
          "rank": 435,
          "turkishWord": "oh",
          "englishWord": "oh"
        },
        {
          "rank": 436,
          "turkishWord": "hızlı",
          "englishWord": "quick"
        },
        {
          "rank": 437,
          "turkishWord": "geliştirmek",
          "englishWord": "develop"
        },
        {
          "rank": 438,
          "turkishWord": "okyanus",
          "englishWord": "ocean"
        },
        {
          "rank": 439,
          "turkishWord": "sıcak",
          "englishWord": "warm"
        },
        {
          "rank": 440,
          "turkishWord": "ücretsiz",
          "englishWord": "free"
        },
        {
          "rank": 441,
          "turkishWord": "dakika",
          "englishWord": "minute"
        },
        {
          "rank": 442,
          "turkishWord": "güçlü",
          "englishWord": "strong"
        },
        {
          "rank": 443,
          "turkishWord": "özel",
          "englishWord": "special"
        },
        {
          "rank": 444,
          "turkishWord": "zihin",
          "englishWord": "mind"
        },
        {
          "rank": 445,
          "turkishWord": "arkasında",
          "englishWord": "behind"
        },
        {
          "rank": 446,
          "turkishWord": "açık",
          "englishWord": "clear"
        },
        {
          "rank": 447,
          "turkishWord": "kuyruk",
          "englishWord": "tail"
        },
        {
          "rank": 448,
          "turkishWord": "üretmek",
          "englishWord": "produce"
        },
        {
          "rank": 449,
          "turkishWord": "gerçek",
          "englishWord": "fact"
        },
        {
          "rank": 450,
          "turkishWord": "uzay",
          "englishWord": "space"
        },
        {
          "rank": 451,
          "turkishWord": "duydum",
          "englishWord": "heard"
        },
        {
          "rank": 453,
          "turkishWord": "saat",
          "englishWord": "hour"
        },
        {
          "rank": 455,
          "turkishWord": "gerçek",
          "englishWord": "true"
        },
        {
          "rank": 456,
          "turkishWord": "sırasında",
          "englishWord": "during"
        },
        {
          "rank": 457,
          "turkishWord": "yüz",
          "englishWord": "hundred"
        },
        {
          "rank": 458,
          "turkishWord": "beş",
          "englishWord": "five"
        },
        {
          "rank": 459,
          "turkishWord": "hatırlıyorum",
          "englishWord": "remember"
        },
        {
          "rank": 460,
          "turkishWord": "adım",
          "englishWord": "step"
        },
        {
          "rank": 461,
          "turkishWord": "erken",
          "englishWord": "early"
        },
        {
          "rank": 462,
          "turkishWord": "tutun",
          "englishWord": "hold"
        },
        {
          "rank": 463,
          "turkishWord": "batı",
          "englishWord": "west"
        },
        {
          "rank": 464,
          "turkishWord": "zemin",
          "englishWord": "ground"
        },
        {
          "rank": 465,
          "turkishWord": "faiz",
          "englishWord": "interest"
        },
        {
          "rank": 466,
          "turkishWord": "ulaşmak",
          "englishWord": "reach"
        },
        {
          "rank": 467,
          "turkishWord": "hızlı",
          "englishWord": "fast"
        },
        {
          "rank": 468,
          "turkishWord": "fiil",
          "englishWord": "verb"
        },
        {
          "rank": 470,
          "turkishWord": "dinle",
          "englishWord": "listen"
        },
        {
          "rank": 471,
          "turkishWord": "altı",
          "englishWord": "six"
        },
        {
          "rank": 472,
          "turkishWord": "tablo",
          "englishWord": "table"
        },
        {
          "rank": 473,
          "turkishWord": "seyahat",
          "englishWord": "travel"
        },
        {
          "rank": 475,
          "turkishWord": "sabah",
          "englishWord": "morning"
        },
        {
          "rank": 476,
          "turkishWord": "on",
          "englishWord": "ten"
        },
        {
          "rank": 477,
          "turkishWord": "basit",
          "englishWord": "simple"
        },
        {
          "rank": 478,
          "turkishWord": "birkaç",
          "englishWord": "several"
        },
        {
          "rank": 479,
          "turkishWord": "ünlü",
          "englishWord": "vowel"
        },
        {
          "rank": 480,
          "turkishWord": "doğru",
          "englishWord": "toward"
        },
        {
          "rank": 481,
          "turkishWord": "savaş",
          "englishWord": "war"
        },
        {
          "rank": 482,
          "turkishWord": "koymak",
          "englishWord": "lay"
        },
        {
          "rank": 483,
          "turkishWord": "karşı",
          "englishWord": "against"
        },
        {
          "rank": 484,
          "turkishWord": "desen",
          "englishWord": "pattern"
        },
        {
          "rank": 485,
          "turkishWord": "yavaş",
          "englishWord": "slow"
        },
        {
          "rank": 486,
          "turkishWord": "merkezi",
          "englishWord": "center"
        },
        {
          "rank": 487,
          "turkishWord": "aşk",
          "englishWord": "love"
        },
        {
          "rank": 488,
          "turkishWord": "kişi",
          "englishWord": "person"
        },
        {
          "rank": 489,
          "turkishWord": "para",
          "englishWord": "money"
        },
        {
          "rank": 490,
          "turkishWord": "hizmet",
          "englishWord": "serve"
        },
        {
          "rank": 491,
          "turkishWord": "görünür",
          "englishWord": "appear"
        },
        {
          "rank": 492,
          "turkishWord": "yol",
          "englishWord": "road"
        },
        {
          "rank": 493,
          "turkishWord": "harita",
          "englishWord": "map"
        },
        {
          "rank": 494,
          "turkishWord": "yağmur",
          "englishWord": "rain"
        },
        {
          "rank": 495,
          "turkishWord": "kural",
          "englishWord": "rule"
        },
        {
          "rank": 496,
          "turkishWord": "idare",
          "englishWord": "govern"
        },
        {
          "rank": 497,
          "turkishWord": "Çek",
          "englishWord": "pull"
        },
        {
          "rank": 498,
          "turkishWord": "soğuk",
          "englishWord": "cold"
        },
        {
          "rank": 499,
          "turkishWord": "haber",
          "englishWord": "notice"
        },
        {
          "rank": 500,
          "turkishWord": "ses",
          "englishWord": "voice"
        },
        {
          "rank": 501,
          "turkishWord": "enerji",
          "englishWord": "energy"
        },
        {
          "rank": 502,
          "turkishWord": "avı",
          "englishWord": "hunt"
        },
        {
          "rank": 503,
          "turkishWord": "muhtemel",
          "englishWord": "probable"
        },
        {
          "rank": 504,
          "turkishWord": "yatak",
          "englishWord": "bed"
        },
        {
          "rank": 505,
          "turkishWord": "kardeş",
          "englishWord": "brother"
        },
        {
          "rank": 506,
          "turkishWord": "yumurta",
          "englishWord": "egg"
        },
        {
          "rank": 507,
          "turkishWord": "binmek",
          "englishWord": "ride"
        },
        {
          "rank": 508,
          "turkishWord": "hücre",
          "englishWord": "cell"
        },
        {
          "rank": 509,
          "turkishWord": "inanıyorum",
          "englishWord": "believe"
        },
        {
          "rank": 510,
          "turkishWord": "belki",
          "englishWord": "perhaps"
        },
        {
          "rank": 511,
          "turkishWord": "seçmek",
          "englishWord": "pick"
        },
        {
          "rank": 512,
          "turkishWord": "ani",
          "englishWord": "sudden"
        },
        {
          "rank": 513,
          "turkishWord": "saymak",
          "englishWord": "count"
        },
        {
          "rank": 514,
          "turkishWord": "kare",
          "englishWord": "square"
        },
        {
          "rank": 515,
          "turkishWord": "neden",
          "englishWord": "reason"
        },
        {
          "rank": 516,
          "turkishWord": "uzunluk",
          "englishWord": "length"
        },
        {
          "rank": 517,
          "turkishWord": "temsil",
          "englishWord": "represent"
        },
        {
          "rank": 518,
          "turkishWord": "sanat",
          "englishWord": "art"
        },
        {
          "rank": 519,
          "turkishWord": "konu",
          "englishWord": "subject"
        },
        {
          "rank": 520,
          "turkishWord": "bölge",
          "englishWord": "region"
        },
        {
          "rank": 521,
          "turkishWord": "boyut",
          "englishWord": "size"
        },
        {
          "rank": 522,
          "turkishWord": "değiştirmek",
          "englishWord": "vary"
        },
        {
          "rank": 523,
          "turkishWord": "yerleşmek",
          "englishWord": "settle"
        },
        {
          "rank": 524,
          "turkishWord": "konuşmak",
          "englishWord": "speak"
        },
        {
          "rank": 525,
          "turkishWord": "ağırlık",
          "englishWord": "weight"
        },
        {
          "rank": 526,
          "turkishWord": "genel",
          "englishWord": "general"
        },
        {
          "rank": 527,
          "turkishWord": "buz",
          "englishWord": "ice"
        },
        {
          "rank": 528,
          "turkishWord": "madde",
          "englishWord": "matter"
        },
        {
          "rank": 529,
          "turkishWord": "daire",
          "englishWord": "circle"
        },
        {
          "rank": 530,
          "turkishWord": "çifti",
          "englishWord": "pair"
        },
        {
          "rank": 531,
          "turkishWord": "dahil",
          "englishWord": "include"
        },
        {
          "rank": 532,
          "turkishWord": "bölmek",
          "englishWord": "divide"
        },
        {
          "rank": 533,
          "turkishWord": "hece",
          "englishWord": "syllable"
        },
        {
          "rank": 534,
          "turkishWord": "keçe",
          "englishWord": "felt"
        },
        {
          "rank": 535,
          "turkishWord": "büyük",
          "englishWord": "grand"
        },
        {
          "rank": 536,
          "turkishWord": "top",
          "englishWord": "ball"
        },
        {
          "rank": 537,
          "turkishWord": "henüz",
          "englishWord": "yet"
        },
        {
          "rank": 538,
          "turkishWord": "dalga",
          "englishWord": "wave"
        },
        {
          "rank": 539,
          "turkishWord": "bırakın",
          "englishWord": "drop"
        },
        {
          "rank": 540,
          "turkishWord": "kalp",
          "englishWord": "heart"
        },
        {
          "rank": 541,
          "turkishWord": "duyuyorum",
          "englishWord": "am"
        },
        {
          "rank": 542,
          "turkishWord": "mevcut",
          "englishWord": "present"
        },
        {
          "rank": 543,
          "turkishWord": "ağır",
          "englishWord": "heavy"
        },
        {
          "rank": 544,
          "turkishWord": "dans",
          "englishWord": "dance"
        },
        {
          "rank": 545,
          "turkishWord": "motor",
          "englishWord": "engine"
        },
        {
          "rank": 546,
          "turkishWord": "pozisyon",
          "englishWord": "position"
        },
        {
          "rank": 547,
          "turkishWord": "kol",
          "englishWord": "arm"
        },
        {
          "rank": 548,
          "turkishWord": "geniş",
          "englishWord": "wide"
        },
        {
          "rank": 549,
          "turkishWord": "yelken",
          "englishWord": "sail"
        },
        {
          "rank": 550,
          "turkishWord": "materyal",
          "englishWord": "material"
        },
        {
          "rank": 551,
          "turkishWord": "kesir",
          "englishWord": "fraction"
        },
        {
          "rank": 552,
          "turkishWord": "orman",
          "englishWord": "forest"
        },
        {
          "rank": 553,
          "turkishWord": "oturmak",
          "englishWord": "sit"
        },
        {
          "rank": 554,
          "turkishWord": "yarış",
          "englishWord": "race"
        },
        {
          "rank": 555,
          "turkishWord": "penceresi",
          "englishWord": "window"
        },
        {
          "rank": 556,
          "turkishWord": "mağaza",
          "englishWord": "store"
        },
        {
          "rank": 557,
          "turkishWord": "yaz",
          "englishWord": "summer"
        },
        {
          "rank": 558,
          "turkishWord": "tren",
          "englishWord": "train"
        },
        {
          "rank": 559,
          "turkishWord": "uyku",
          "englishWord": "sleep"
        },
        {
          "rank": 560,
          "turkishWord": "kanıtlamak",
          "englishWord": "prove"
        },
        {
          "rank": 561,
          "turkishWord": "yalnız",
          "englishWord": "lone"
        },
        {
          "rank": 562,
          "turkishWord": "bacak",
          "englishWord": "leg"
        },
        {
          "rank": 563,
          "turkishWord": "egzersiz",
          "englishWord": "exercise"
        },
        {
          "rank": 564,
          "turkishWord": "duvar",
          "englishWord": "wall"
        },
        {
          "rank": 566,
          "turkishWord": "dağ",
          "englishWord": "mount"
        },
        {
          "rank": 567,
          "turkishWord": "dilek",
          "englishWord": "wish"
        },
        {
          "rank": 568,
          "turkishWord": "gökyüzü",
          "englishWord": "sky"
        },
        {
          "rank": 569,
          "turkishWord": "kurulu",
          "englishWord": "board"
        },
        {
          "rank": 570,
          "turkishWord": "sevinç",
          "englishWord": "joy"
        },
        {
          "rank": 571,
          "turkishWord": "kış",
          "englishWord": "winter"
        },
        {
          "rank": 573,
          "turkishWord": "yazılı",
          "englishWord": "written"
        },
        {
          "rank": 574,
          "turkishWord": "vahşi",
          "englishWord": "wild"
        },
        {
          "rank": 575,
          "turkishWord": "enstrüman",
          "englishWord": "instrument"
        },
        {
          "rank": 576,
          "turkishWord": "tuttu",
          "englishWord": "kept"
        },
        {
          "rank": 577,
          "turkishWord": "cam",
          "englishWord": "glass"
        },
        {
          "rank": 578,
          "turkishWord": "çim",
          "englishWord": "grass"
        },
        {
          "rank": 579,
          "turkishWord": "inek",
          "englishWord": "cow"
        },
        {
          "rank": 580,
          "turkishWord": "iş",
          "englishWord": "job"
        },
        {
          "rank": 581,
          "turkishWord": "kenar",
          "englishWord": "edge"
        },
        {
          "rank": 582,
          "turkishWord": "işareti",
          "englishWord": "sign"
        },
        {
          "rank": 583,
          "turkishWord": "ziyareti",
          "englishWord": "visit"
        },
        {
          "rank": 584,
          "turkishWord": "geçmiş",
          "englishWord": "past"
        },
        {
          "rank": 585,
          "turkishWord": "yumuşak",
          "englishWord": "soft"
        },
        {
          "rank": 586,
          "turkishWord": "eğlenceli",
          "englishWord": "fun"
        },
        {
          "rank": 587,
          "turkishWord": "parlak",
          "englishWord": "bright"
        },
        {
          "rank": 588,
          "turkishWord": "gaz",
          "englishWord": "gas"
        },
        {
          "rank": 589,
          "turkishWord": "hava",
          "englishWord": "weather"
        },
        {
          "rank": 590,
          "turkishWord": "ay",
          "englishWord": "month"
        },
        {
          "rank": 591,
          "turkishWord": "milyon",
          "englishWord": "million"
        },
        {
          "rank": 592,
          "turkishWord": "ayı",
          "englishWord": "bear"
        },
        {
          "rank": 593,
          "turkishWord": "bitirmek",
          "englishWord": "finish"
        },
        {
          "rank": 594,
          "turkishWord": "mutlu",
          "englishWord": "happy"
        },
        {
          "rank": 595,
          "turkishWord": "umut",
          "englishWord": "hope"
        },
        {
          "rank": 596,
          "turkishWord": "çiçek",
          "englishWord": "flower"
        },
        {
          "rank": 597,
          "turkishWord": "giydirmek",
          "englishWord": "clothe"
        },
        {
          "rank": 598,
          "turkishWord": "garip",
          "englishWord": "strange"
        },
        {
          "rank": 599,
          "turkishWord": "gitti",
          "englishWord": "gone"
        },
        {
          "rank": 600,
          "turkishWord": "ticaret",
          "englishWord": "trade"
        },
        {
          "rank": 601,
          "turkishWord": "melodi",
          "englishWord": "melody"
        },
        {
          "rank": 602,
          "turkishWord": "gezi",
          "englishWord": "trip"
        },
        {
          "rank": 603,
          "turkishWord": "ofis",
          "englishWord": "office"
        },
        {
          "rank": 604,
          "turkishWord": "almak",
          "englishWord": "receive"
        },
        {
          "rank": 605,
          "turkishWord": "satır",
          "englishWord": "row"
        },
        {
          "rank": 606,
          "turkishWord": "ağız",
          "englishWord": "mouth"
        },
        {
          "rank": 607,
          "turkishWord": "tam",
          "englishWord": "exact"
        },
        {
          "rank": 608,
          "turkishWord": "sembol",
          "englishWord": "symbol"
        },
        {
          "rank": 609,
          "turkishWord": "ölmek",
          "englishWord": "die"
        },
        {
          "rank": 610,
          "turkishWord": "en az",
          "englishWord": "least"
        },
        {
          "rank": 611,
          "turkishWord": "sorun",
          "englishWord": "trouble"
        },
        {
          "rank": 612,
          "turkishWord": "bağırmak",
          "englishWord": "shout"
        },
        {
          "rank": 613,
          "turkishWord": "hariç",
          "englishWord": "except"
        },
        {
          "rank": 614,
          "turkishWord": "yazdı",
          "englishWord": "wrote"
        },
        {
          "rank": 615,
          "turkishWord": "tohum",
          "englishWord": "seed"
        },
        {
          "rank": 616,
          "turkishWord": "sesi",
          "englishWord": "tone"
        },
        {
          "rank": 617,
          "turkishWord": "katılmak",
          "englishWord": "join"
        },
        {
          "rank": 618,
          "turkishWord": "önermek",
          "englishWord": "suggest"
        },
        {
          "rank": 619,
          "turkishWord": "temiz",
          "englishWord": "clean"
        },
        {
          "rank": 620,
          "turkishWord": "molası",
          "englishWord": "break"
        },
        {
          "rank": 621,
          "turkishWord": "bayan",
          "englishWord": "lady"
        },
        {
          "rank": 622,
          "turkishWord": "yarda",
          "englishWord": "yard"
        },
        {
          "rank": 623,
          "turkishWord": "yükselecek",
          "englishWord": "rise"
        },
        {
          "rank": 624,
          "turkishWord": "kötü",
          "englishWord": "bad"
        },
        {
          "rank": 625,
          "turkishWord": "darbe",
          "englishWord": "blow"
        },
        {
          "rank": 626,
          "turkishWord": "yağ",
          "englishWord": "oil"
        },
        {
          "rank": 627,
          "turkishWord": "kan",
          "englishWord": "blood"
        },
        {
          "rank": 628,
          "turkishWord": "dokunma",
          "englishWord": "touch"
        },
        {
          "rank": 629,
          "turkishWord": "büyüdü",
          "englishWord": "grew"
        },
        {
          "rank": 630,
          "turkishWord": "yüzde",
          "englishWord": "cent"
        },
        {
          "rank": 631,
          "turkishWord": "karıştırmak",
          "englishWord": "mix"
        },
        {
          "rank": 632,
          "turkishWord": "takım",
          "englishWord": "team"
        },
        {
          "rank": 633,
          "turkishWord": "tel",
          "englishWord": "wire"
        },
        {
          "rank": 634,
          "turkishWord": "maliyet",
          "englishWord": "cost"
        },
        {
          "rank": 635,
          "turkishWord": "kaybetti",
          "englishWord": "lost"
        },
        {
          "rank": 636,
          "turkishWord": "kahverengi",
          "englishWord": "brown"
        },
        {
          "rank": 637,
          "turkishWord": "giymek",
          "englishWord": "wear"
        },
        {
          "rank": 638,
          "turkishWord": "bahçe",
          "englishWord": "garden"
        },
        {
          "rank": 639,
          "turkishWord": "eşit",
          "englishWord": "equal"
        },
        {
          "rank": 640,
          "turkishWord": "gönderildi",
          "englishWord": "sent"
        },
        {
          "rank": 641,
          "turkishWord": "seçim",
          "englishWord": "choose"
        },
        {
          "rank": 642,
          "turkishWord": "düştü",
          "englishWord": "fell"
        },
        {
          "rank": 643,
          "turkishWord": "uygun",
          "englishWord": "fit"
        },
        {
          "rank": 644,
          "turkishWord": "akış",
          "englishWord": "flow"
        },
        {
          "rank": 645,
          "turkishWord": "adil",
          "englishWord": "fair"
        },
        {
          "rank": 646,
          "turkishWord": "banka",
          "englishWord": "bank"
        },
        {
          "rank": 647,
          "turkishWord": "toplamak",
          "englishWord": "collect"
        },
        {
          "rank": 648,
          "turkishWord": "kaydetmek",
          "englishWord": "save"
        },
        {
          "rank": 649,
          "turkishWord": "kontrolü",
          "englishWord": "control"
        },
        {
          "rank": 650,
          "turkishWord": "ondalık",
          "englishWord": "decimal"
        },
        {
          "rank": 651,
          "turkishWord": "kulak",
          "englishWord": "ear"
        },
        {
          "rank": 652,
          "turkishWord": "başka",
          "englishWord": "else"
        },
        {
          "rank": 653,
          "turkishWord": "oldukça",
          "englishWord": "quite"
        },
        {
          "rank": 654,
          "turkishWord": "kırdı",
          "englishWord": "broke"
        },
        {
          "rank": 655,
          "turkishWord": "dava",
          "englishWord": "case"
        },
        {
          "rank": 656,
          "turkishWord": "orta",
          "englishWord": "middle"
        },
        {
          "rank": 657,
          "turkishWord": "öldürmek",
          "englishWord": "kill"
        },
        {
          "rank": 658,
          "turkishWord": "oğlu",
          "englishWord": "son"
        },
        {
          "rank": 659,
          "turkishWord": "göl",
          "englishWord": "lake"
        },
        {
          "rank": 660,
          "turkishWord": "an",
          "englishWord": "moment"
        },
        {
          "rank": 661,
          "turkishWord": "ölçek",
          "englishWord": "scale"
        },
        {
          "rank": 663,
          "turkishWord": "bahar",
          "englishWord": "spring"
        },
        {
          "rank": 664,
          "turkishWord": "gözlemlemek",
          "englishWord": "observe"
        },
        {
          "rank": 665,
          "turkishWord": "çocuk",
          "englishWord": "child"
        },
        {
          "rank": 666,
          "turkishWord": "düz",
          "englishWord": "straight"
        },
        {
          "rank": 667,
          "turkishWord": "ünsüz",
          "englishWord": "consonant"
        },
        {
          "rank": 668,
          "turkishWord": "ulus",
          "englishWord": "nation"
        },
        {
          "rank": 669,
          "turkishWord": "Sözlük",
          "englishWord": "dictionary"
        },
        {
          "rank": 670,
          "turkishWord": "süt",
          "englishWord": "milk"
        },
        {
          "rank": 671,
          "turkishWord": "hız",
          "englishWord": "speed"
        },
        {
          "rank": 672,
          "turkishWord": "yöntem",
          "englishWord": "method"
        },
        {
          "rank": 673,
          "turkishWord": "Organ",
          "englishWord": "organ"
        },
        {
          "rank": 674,
          "turkishWord": "ödeme",
          "englishWord": "pay"
        },
        {
          "rank": 675,
          "turkishWord": "yaş",
          "englishWord": "age"
        },
        {
          "rank": 676,
          "turkishWord": "bölüm",
          "englishWord": "section"
        },
        {
          "rank": 677,
          "turkishWord": "elbise",
          "englishWord": "dress"
        },
        {
          "rank": 678,
          "turkishWord": "bulut",
          "englishWord": "cloud"
        },
        {
          "rank": 679,
          "turkishWord": "sürpriz",
          "englishWord": "surprise"
        },
        {
          "rank": 680,
          "turkishWord": "sessiz",
          "englishWord": "quiet"
        },
        {
          "rank": 681,
          "turkishWord": "taş",
          "englishWord": "stone"
        },
        {
          "rank": 682,
          "turkishWord": "küçücük",
          "englishWord": "tiny"
        },
        {
          "rank": 683,
          "turkishWord": "tırmanış",
          "englishWord": "climb"
        },
        {
          "rank": 684,
          "turkishWord": "serin",
          "englishWord": "cool"
        },
        {
          "rank": 685,
          "turkishWord": "dizayn",
          "englishWord": "design"
        },
        {
          "rank": 686,
          "turkishWord": "kötü",
          "englishWord": "poor"
        },
        {
          "rank": 687,
          "turkishWord": "çok",
          "englishWord": "lot"
        },
        {
          "rank": 688,
          "turkishWord": "deneme",
          "englishWord": "experiment"
        },
        {
          "rank": 689,
          "turkishWord": "alt",
          "englishWord": "bottom"
        },
        {
          "rank": 690,
          "turkishWord": "anahtar",
          "englishWord": "key"
        },
        {
          "rank": 691,
          "turkishWord": "demir",
          "englishWord": "iron"
        },
        {
          "rank": 692,
          "turkishWord": "tek",
          "englishWord": "single"
        },
        {
          "rank": 693,
          "turkishWord": "sopa",
          "englishWord": "stick"
        },
        {
          "rank": 694,
          "turkishWord": "düz",
          "englishWord": "flat"
        },
        {
          "rank": 695,
          "turkishWord": "yirmi",
          "englishWord": "twenty"
        },
        {
          "rank": 696,
          "turkishWord": "cilt",
          "englishWord": "skin"
        },
        {
          "rank": 697,
          "turkishWord": "gülümseme",
          "englishWord": "smile"
        },
        {
          "rank": 698,
          "turkishWord": "kırışık",
          "englishWord": "crease"
        },
        {
          "rank": 699,
          "turkishWord": "delik",
          "englishWord": "hole"
        },
        {
          "rank": 700,
          "turkishWord": "atlama",
          "englishWord": "jump"
        },
        {
          "rank": 701,
          "turkishWord": "bebek",
          "englishWord": "baby"
        },
        {
          "rank": 702,
          "turkishWord": "sekiz",
          "englishWord": "eight"
        },
        {
          "rank": 703,
          "turkishWord": "köy",
          "englishWord": "village"
        },
        {
          "rank": 704,
          "turkishWord": "karşılamak",
          "englishWord": "meet"
        },
        {
          "rank": 705,
          "turkishWord": "kök",
          "englishWord": "root"
        },
        {
          "rank": 706,
          "turkishWord": "satın",
          "englishWord": "buy"
        },
        {
          "rank": 707,
          "turkishWord": "yükseltmek",
          "englishWord": "raise"
        },
        {
          "rank": 708,
          "turkishWord": "çözmek",
          "englishWord": "solve"
        },
        {
          "rank": 709,
          "turkishWord": "metal",
          "englishWord": "metal"
        },
        {
          "rank": 710,
          "turkishWord": "olsun",
          "englishWord": "whether"
        },
        {
          "rank": 711,
          "turkishWord": "it",
          "englishWord": "push"
        },
        {
          "rank": 712,
          "turkishWord": "yedi",
          "englishWord": "seven"
        },
        {
          "rank": 713,
          "turkishWord": "paragraf",
          "englishWord": "paragraph"
        },
        {
          "rank": 714,
          "turkishWord": "üçüncü",
          "englishWord": "third"
        },
        {
          "rank": 716,
          "turkishWord": "tutulan",
          "englishWord": "held"
        },
        {
          "rank": 717,
          "turkishWord": "saç",
          "englishWord": "hair"
        },
        {
          "rank": 718,
          "turkishWord": "tanımlamak",
          "englishWord": "describe"
        },
        {
          "rank": 719,
          "turkishWord": "aşçı",
          "englishWord": "cook"
        },
        {
          "rank": 720,
          "turkishWord": "zemin",
          "englishWord": "floor"
        },
        {
          "rank": 722,
          "turkishWord": "sonuç",
          "englishWord": "result"
        },
        {
          "rank": 723,
          "turkishWord": "yanmak",
          "englishWord": "burn"
        },
        {
          "rank": 724,
          "turkishWord": "tepe",
          "englishWord": "hill"
        },
        {
          "rank": 725,
          "turkishWord": "güvenli",
          "englishWord": "safe"
        },
        {
          "rank": 726,
          "turkishWord": "kedi",
          "englishWord": "cat"
        },
        {
          "rank": 727,
          "turkishWord": "yüzyıl",
          "englishWord": "century"
        },
        {
          "rank": 728,
          "turkishWord": "düşünmek",
          "englishWord": "consider"
        },
        {
          "rank": 729,
          "turkishWord": "tipi",
          "englishWord": "type"
        },
        {
          "rank": 730,
          "turkishWord": "hukuk",
          "englishWord": "law"
        },
        {
          "rank": 731,
          "turkishWord": "bit",
          "englishWord": "bit"
        },
        {
          "rank": 732,
          "turkishWord": "sahil",
          "englishWord": "coast"
        },
        {
          "rank": 733,
          "turkishWord": "kopya",
          "englishWord": "copy"
        },
        {
          "rank": 734,
          "turkishWord": "ifade",
          "englishWord": "phrase"
        },
        {
          "rank": 735,
          "turkishWord": "sessiz",
          "englishWord": "silent"
        },
        {
          "rank": 737,
          "turkishWord": "kum",
          "englishWord": "sand"
        },
        {
          "rank": 738,
          "turkishWord": "toprak",
          "englishWord": "soil"
        },
        {
          "rank": 739,
          "turkishWord": "rulo",
          "englishWord": "roll"
        },
        {
          "rank": 740,
          "turkishWord": "sıcaklık",
          "englishWord": "temperature"
        },
        {
          "rank": 741,
          "turkishWord": "parmak",
          "englishWord": "finger"
        },
        {
          "rank": 742,
          "turkishWord": "sanayi",
          "englishWord": "industry"
        },
        {
          "rank": 743,
          "turkishWord": "değeri",
          "englishWord": "value"
        },
        {
          "rank": 744,
          "turkishWord": "kavga",
          "englishWord": "fight"
        },
        {
          "rank": 745,
          "turkishWord": "yalan",
          "englishWord": "lie"
        },
        {
          "rank": 746,
          "turkishWord": "yendi",
          "englishWord": "beat"
        },
        {
          "rank": 747,
          "turkishWord": "heyecanlandırmak",
          "englishWord": "excite"
        },
        {
          "rank": 748,
          "turkishWord": "doğal",
          "englishWord": "natural"
        },
        {
          "rank": 749,
          "turkishWord": "görünüm",
          "englishWord": "view"
        },
        {
          "rank": 750,
          "turkishWord": "sense",
          "englishWord": "sense"
        },
        {
          "rank": 751,
          "turkishWord": "sermaye",
          "englishWord": "capital"
        },
        {
          "rank": 752,
          "turkishWord": "olmaz",
          "englishWord": "won’t"
        },
        {
          "rank": 753,
          "turkishWord": "sandalye",
          "englishWord": "chair"
        },
        {
          "rank": 754,
          "turkishWord": "tehlike",
          "englishWord": "danger"
        },
        {
          "rank": 755,
          "turkishWord": "meyve",
          "englishWord": "fruit"
        },
        {
          "rank": 756,
          "turkishWord": "zengin",
          "englishWord": "rich"
        },
        {
          "rank": 757,
          "turkishWord": "kalın",
          "englishWord": "thick"
        },
        {
          "rank": 758,
          "turkishWord": "asker",
          "englishWord": "soldier"
        },
        {
          "rank": 759,
          "turkishWord": "süreç",
          "englishWord": "process"
        },
        {
          "rank": 760,
          "turkishWord": "işletmek",
          "englishWord": "operate"
        },
        {
          "rank": 761,
          "turkishWord": "uygulama",
          "englishWord": "practice"
        },
        {
          "rank": 762,
          "turkishWord": "ayrı",
          "englishWord": "separate"
        },
        {
          "rank": 763,
          "turkishWord": "zor",
          "englishWord": "difficult"
        },
        {
          "rank": 764,
          "turkishWord": "doktor",
          "englishWord": "doctor"
        },
        {
          "rank": 765,
          "turkishWord": "lütfen",
          "englishWord": "please"
        },
        {
          "rank": 766,
          "turkishWord": "korumak",
          "englishWord": "protect"
        },
        {
          "rank": 767,
          "turkishWord": "öğlen",
          "englishWord": "noon"
        },
        {
          "rank": 768,
          "turkishWord": "kırpma",
          "englishWord": "crop"
        },
        {
          "rank": 769,
          "turkishWord": "çağdaş",
          "englishWord": "modern"
        },
        {
          "rank": 770,
          "turkishWord": "eleman",
          "englishWord": "element"
        },
        {
          "rank": 771,
          "turkishWord": "vurmak",
          "englishWord": "hit"
        },
        {
          "rank": 772,
          "turkishWord": "öğrenci",
          "englishWord": "student"
        },
        {
          "rank": 773,
          "turkishWord": "köşe",
          "englishWord": "corner"
        },
        {
          "rank": 774,
          "turkishWord": "parti",
          "englishWord": "party"
        },
        {
          "rank": 775,
          "turkishWord": "besleme",
          "englishWord": "supply"
        },
        {
          "rank": 776,
          "turkishWord": "kimin",
          "englishWord": "whose"
        },
        {
          "rank": 777,
          "turkishWord": "yerleştirmek",
          "englishWord": "locate"
        },
        {
          "rank": 778,
          "turkishWord": "halka",
          "englishWord": "ring"
        },
        {
          "rank": 779,
          "turkishWord": "karakter",
          "englishWord": "character"
        },
        {
          "rank": 780,
          "turkishWord": "böcek",
          "englishWord": "insect"
        },
        {
          "rank": 781,
          "turkishWord": "yakalandı",
          "englishWord": "caught"
        },
        {
          "rank": 782,
          "turkishWord": "dönemi",
          "englishWord": "period"
        },
        {
          "rank": 783,
          "turkishWord": "göstermektedir",
          "englishWord": "indicate"
        },
        {
          "rank": 784,
          "turkishWord": "radyo",
          "englishWord": "radio"
        },
        {
          "rank": 785,
          "turkishWord": "konuştu",
          "englishWord": "spoke"
        },
        {
          "rank": 786,
          "turkishWord": "atomudur",
          "englishWord": "atom"
        },
        {
          "rank": 787,
          "turkishWord": "insan",
          "englishWord": "human"
        },
        {
          "rank": 788,
          "turkishWord": "geçmişi",
          "englishWord": "history"
        },
        {
          "rank": 789,
          "turkishWord": "etkisi",
          "englishWord": "effect"
        },
        {
          "rank": 790,
          "turkishWord": "elektrik",
          "englishWord": "electric"
        },
        {
          "rank": 791,
          "turkishWord": "bekliyoruz",
          "englishWord": "expect"
        },
        {
          "rank": 792,
          "turkishWord": "kemik",
          "englishWord": "bone"
        },
        {
          "rank": 793,
          "turkishWord": "demiryolu",
          "englishWord": "rail"
        },
        {
          "rank": 794,
          "turkishWord": "hayal",
          "englishWord": "imagine"
        },
        {
          "rank": 795,
          "turkishWord": "sağlamak",
          "englishWord": "provide"
        },
        {
          "rank": 796,
          "turkishWord": "katılıyorum",
          "englishWord": "agree"
        },
        {
          "rank": 797,
          "turkishWord": "böylece",
          "englishWord": "thus"
        },
        {
          "rank": 798,
          "turkishWord": "nazik",
          "englishWord": "gentle"
        },
        {
          "rank": 799,
          "turkishWord": "kadın",
          "englishWord": "woman"
        },
        {
          "rank": 800,
          "turkishWord": "kaptan",
          "englishWord": "captain"
        },
        {
          "rank": 801,
          "turkishWord": "sanırım",
          "englishWord": "guess"
        },
        {
          "rank": 802,
          "turkishWord": "gerekli",
          "englishWord": "necessary"
        },
        {
          "rank": 803,
          "turkishWord": "keskin",
          "englishWord": "sharp"
        },
        {
          "rank": 804,
          "turkishWord": "kanat",
          "englishWord": "wing"
        },
        {
          "rank": 805,
          "turkishWord": "oluşturmak",
          "englishWord": "create"
        },
        {
          "rank": 806,
          "turkishWord": "komşu",
          "englishWord": "neighbor"
        },
        {
          "rank": 807,
          "turkishWord": "yıkama",
          "englishWord": "wash"
        },
        {
          "rank": 808,
          "turkishWord": "yarasa",
          "englishWord": "bat"
        },
        {
          "rank": 809,
          "turkishWord": "yerine",
          "englishWord": "rather"
        },
        {
          "rank": 810,
          "turkishWord": "kalabalık",
          "englishWord": "crowd"
        },
        {
          "rank": 811,
          "turkishWord": "mısır",
          "englishWord": "corn"
        },
        {
          "rank": 812,
          "turkishWord": "karşılaştırma",
          "englishWord": "compare"
        },
        {
          "rank": 813,
          "turkishWord": "şiir",
          "englishWord": "poem"
        },
        {
          "rank": 814,
          "turkishWord": "dize",
          "englishWord": "string"
        },
        {
          "rank": 815,
          "turkishWord": "çan",
          "englishWord": "bell"
        },
        {
          "rank": 816,
          "turkishWord": "bağlı",
          "englishWord": "depend"
        },
        {
          "rank": 817,
          "turkishWord": "et",
          "englishWord": "meat"
        },
        {
          "rank": 818,
          "turkishWord": "ovmak",
          "englishWord": "rub"
        },
        {
          "rank": 819,
          "turkishWord": "tüp",
          "englishWord": "tube"
        },
        {
          "rank": 820,
          "turkishWord": "ünlü",
          "englishWord": "famous"
        },
        {
          "rank": 921,
          "turkishWord": "dolar",
          "englishWord": "dollar"
        },
        {
          "rank": 822,
          "turkishWord": "akışı",
          "englishWord": "stream"
        },
        {
          "rank": 823,
          "turkishWord": "korku",
          "englishWord": "fear"
        },
        {
          "rank": 284,
          "turkishWord": "görüş",
          "englishWord": "sight"
        },
        {
          "rank": 825,
          "turkishWord": "ince",
          "englishWord": "thin"
        },
        {
          "rank": 826,
          "turkishWord": "üçgen",
          "englishWord": "triangle"
        },
        {
          "rank": 827,
          "turkishWord": "gezegen",
          "englishWord": "planet"
        },
        {
          "rank": 828,
          "turkishWord": "acele",
          "englishWord": "hurry"
        },
        {
          "rank": 829,
          "turkishWord": "baş",
          "englishWord": "chief"
        },
        {
          "rank": 830,
          "turkishWord": "koloni",
          "englishWord": "colony"
        },
        {
          "rank": 831,
          "turkishWord": "saat",
          "englishWord": "clock"
        },
        {
          "rank": 832,
          "turkishWord": "mayın",
          "englishWord": "mine"
        },
        {
          "rank": 833,
          "turkishWord": "kravat",
          "englishWord": "tie"
        },
        {
          "rank": 834,
          "turkishWord": "girin",
          "englishWord": "enter"
        },
        {
          "rank": 835,
          "turkishWord": "büyük",
          "englishWord": "major"
        },
        {
          "rank": 836,
          "turkishWord": "taze",
          "englishWord": "fresh"
        },
        {
          "rank": 837,
          "turkishWord": "arama",
          "englishWord": "search"
        },
        {
          "rank": 838,
          "turkishWord": "göndermek",
          "englishWord": "send"
        },
        {
          "rank": 839,
          "turkishWord": "sarı",
          "englishWord": "yellow"
        },
        {
          "rank": 840,
          "turkishWord": "gun",
          "englishWord": "gun"
        },
        {
          "rank": 841,
          "turkishWord": "izin",
          "englishWord": "allow"
        },
        {
          "rank": 842,
          "turkishWord": "baskı",
          "englishWord": "print"
        },
        {
          "rank": 843,
          "turkishWord": "ölü",
          "englishWord": "dead"
        },
        {
          "rank": 844,
          "turkishWord": "nokta",
          "englishWord": "spot"
        },
        {
          "rank": 845,
          "turkishWord": "çöl",
          "englishWord": "desert"
        },
        {
          "rank": 847,
          "turkishWord": "akım",
          "englishWord": "current"
        },
        {
          "rank": 848,
          "turkishWord": "asansör",
          "englishWord": "lift"
        },
        {
          "rank": 840,
          "turkishWord": "gül",
          "englishWord": "rose"
        },
        {
          "rank": 850,
          "turkishWord": "varmak",
          "englishWord": "arrive"
        },
        {
          "rank": 851,
          "turkishWord": "usta",
          "englishWord": "master"
        },
        {
          "rank": 852,
          "turkishWord": "iz",
          "englishWord": "track"
        },
        {
          "rank": 853,
          "turkishWord": "ebeveyn",
          "englishWord": "parent"
        },
        {
          "rank": 854,
          "turkishWord": "kıyı",
          "englishWord": "shore"
        },
        {
          "rank": 855,
          "turkishWord": "bölünme",
          "englishWord": "division"
        },
        {
          "rank": 856,
          "turkishWord": "levha",
          "englishWord": "sheet"
        },
        {
          "rank": 857,
          "turkishWord": "madde",
          "englishWord": "substance"
        },
        {
          "rank": 858,
          "turkishWord": "iyilik",
          "englishWord": "favor"
        },
        {
          "rank": 859,
          "turkishWord": "bağlamak",
          "englishWord": "connect"
        },
        {
          "rank": 860,
          "turkishWord": "sonrası",
          "englishWord": "post"
        },
        {
          "rank": 861,
          "turkishWord": "harcamak",
          "englishWord": "spend"
        },
        {
          "rank": 862,
          "turkishWord": "akor",
          "englishWord": "chord"
        },
        {
          "rank": 863,
          "turkishWord": "şişman",
          "englishWord": "fat"
        },
        {
          "rank": 864,
          "turkishWord": "memnun",
          "englishWord": "glad"
        },
        {
          "rank": 865,
          "turkishWord": "orijinal",
          "englishWord": "original"
        },
        {
          "rank": 866,
          "turkishWord": "payı",
          "englishWord": "share"
        },
        {
          "rank": 867,
          "turkishWord": "istasyon",
          "englishWord": "station"
        },
        {
          "rank": 868,
          "turkishWord": "baba",
          "englishWord": "dad"
        },
        {
          "rank": 869,
          "turkishWord": "ekmek",
          "englishWord": "bread"
        },
        {
          "rank": 870,
          "turkishWord": "şarj",
          "englishWord": "charge"
        },
        {
          "rank": 871,
          "turkishWord": "uygun",
          "englishWord": "proper"
        },
        {
          "rank": 872,
          "turkishWord": "bar",
          "englishWord": "bar"
        },
        {
          "rank": 873,
          "turkishWord": "teklif",
          "englishWord": "offer"
        },
        {
          "rank": 874,
          "turkishWord": "segmenti",
          "englishWord": "segment"
        },
        {
          "rank": 875,
          "turkishWord": "köle",
          "englishWord": "slave"
        },
        {
          "rank": 876,
          "turkishWord": "ördek",
          "englishWord": "duck"
        },
        {
          "rank": 877,
          "turkishWord": "anlık",
          "englishWord": "instant"
        },
        {
          "rank": 878,
          "turkishWord": "pazar",
          "englishWord": "market"
        },
        {
          "rank": 879,
          "turkishWord": "derecesi",
          "englishWord": "degree"
        },
        {
          "rank": 880,
          "turkishWord": "doldurmak",
          "englishWord": "populate"
        },
        {
          "rank": 881,
          "turkishWord": "civciv",
          "englishWord": "chick"
        },
        {
          "rank": 882,
          "turkishWord": "sevgili",
          "englishWord": "dear"
        },
        {
          "rank": 883,
          "turkishWord": "düşman",
          "englishWord": "enemy"
        },
        {
          "rank": 884,
          "turkishWord": "cevap",
          "englishWord": "reply"
        },
        {
          "rank": 885,
          "turkishWord": "içki",
          "englishWord": "drink"
        },
        {
          "rank": 886,
          "turkishWord": "meydana",
          "englishWord": "occur"
        },
        {
          "rank": 887,
          "turkishWord": "destek",
          "englishWord": "support"
        },
        {
          "rank": 888,
          "turkishWord": "konuşma",
          "englishWord": "speech"
        },
        {
          "rank": 889,
          "turkishWord": "doğa",
          "englishWord": "nature"
        },
        {
          "rank": 890,
          "turkishWord": "aralığı",
          "englishWord": "range"
        },
        {
          "rank": 891,
          "turkishWord": "buhar",
          "englishWord": "steam"
        },
        {
          "rank": 892,
          "turkishWord": "hareket",
          "englishWord": "motion"
        },
        {
          "rank": 893,
          "turkishWord": "yol",
          "englishWord": "path"
        },
        {
          "rank": 894,
          "turkishWord": "sıvı",
          "englishWord": "liquid"
        },
        {
          "rank": 896,
          "turkishWord": "demek",
          "englishWord": "meant"
        },
        {
          "rank": 897,
          "turkishWord": "bölüm",
          "englishWord": "quotient"
        },
        {
          "rank": 898,
          "turkishWord": "dişler",
          "englishWord": "teeth"
        },
        {
          "rank": 899,
          "turkishWord": "kabuk",
          "englishWord": "shell"
        },
        {
          "rank": 900,
          "turkishWord": "boyun",
          "englishWord": "neck"
        },
        {
          "rank": 901,
          "turkishWord": "oksijen",
          "englishWord": "oxygen"
        },
        {
          "rank": 902,
          "turkishWord": "şeker",
          "englishWord": "sugar"
        },
        {
          "rank": 903,
          "turkishWord": "ölüm",
          "englishWord": "death"
        },
        {
          "rank": 904,
          "turkishWord": "güzel",
          "englishWord": "pretty"
        },
        {
          "rank": 905,
          "turkishWord": "beceri",
          "englishWord": "skill"
        },
        {
          "rank": 906,
          "turkishWord": "kadın",
          "englishWord": "women"
        },
        {
          "rank": 907,
          "turkishWord": "sezon",
          "englishWord": "season"
        },
        {
          "rank": 908,
          "turkishWord": "çözüm",
          "englishWord": "solution"
        },
        {
          "rank": 909,
          "turkishWord": "mıknatıs",
          "englishWord": "magnet"
        },
        {
          "rank": 910,
          "turkishWord": "gümüş",
          "englishWord": "silver"
        },
        {
          "rank": 911,
          "turkishWord": "teşekkürler",
          "englishWord": "thank"
        },
        {
          "rank": 912,
          "turkishWord": "şube",
          "englishWord": "branch"
        },
        {
          "rank": 913,
          "turkishWord": "maç",
          "englishWord": "match"
        },
        {
          "rank": 914,
          "turkishWord": "sonek",
          "englishWord": "suffix"
        },
        {
          "rank": 915,
          "turkishWord": "özellikle",
          "englishWord": "especially"
        },
        {
          "rank": 916,
          "turkishWord": "incir",
          "englishWord": "fig"
        },
        {
          "rank": 917,
          "turkishWord": "korkuyor",
          "englishWord": "afraid"
        },
        {
          "rank": 918,
          "turkishWord": "büyük",
          "englishWord": "huge"
        },
        {
          "rank": 919,
          "turkishWord": "kardeş",
          "englishWord": "sister"
        },
        {
          "rank": 920,
          "turkishWord": "çelik",
          "englishWord": "steel"
        },
        {
          "rank": 921,
          "turkishWord": "tartışmak",
          "englishWord": "discuss"
        },
        {
          "rank": 922,
          "turkishWord": "ileri",
          "englishWord": "forward"
        },
        {
          "rank": 923,
          "turkishWord": "benzer",
          "englishWord": "similar"
        },
        {
          "rank": 924,
          "turkishWord": "kılavuz",
          "englishWord": "guide"
        },
        {
          "rank": 925,
          "turkishWord": "deneyim",
          "englishWord": "experience"
        },
        {
          "rank": 926,
          "turkishWord": "puan",
          "englishWord": "score"
        },
        {
          "rank": 927,
          "turkishWord": "elma",
          "englishWord": "apple"
        },
        {
          "rank": 929,
          "turkishWord": "açtı",
          "englishWord": "led"
        },
        {
          "rank": 930,
          "turkishWord": "zift",
          "englishWord": "pitch"
        },
        {
          "rank": 931,
          "turkishWord": "ceket",
          "englishWord": "coat"
        },
        {
          "rank": 932,
          "turkishWord": "kitle",
          "englishWord": "mass"
        },
        {
          "rank": 933,
          "turkishWord": "kart",
          "englishWord": "card"
        },
        {
          "rank": 934,
          "turkishWord": "bant",
          "englishWord": "band"
        },
        {
          "rank": 935,
          "turkishWord": "halat",
          "englishWord": "rope"
        },
        {
          "rank": 936,
          "turkishWord": "kayma",
          "englishWord": "slip"
        },
        {
          "rank": 937,
          "turkishWord": "win",
          "englishWord": "win"
        },
        {
          "rank": 938,
          "turkishWord": "rüya",
          "englishWord": "dream"
        },
        {
          "rank": 939,
          "turkishWord": "akşam",
          "englishWord": "evening"
        },
        {
          "rank": 940,
          "turkishWord": "durumu",
          "englishWord": "condition"
        },
        {
          "rank": 941,
          "turkishWord": "beslemek",
          "englishWord": "feed"
        },
        {
          "rank": 942,
          "turkishWord": "aracı",
          "englishWord": "tool"
        },
        {
          "rank": 943,
          "turkishWord": "toplam",
          "englishWord": "total"
        },
        {
          "rank": 944,
          "turkishWord": "temel",
          "englishWord": "basic"
        },
        {
          "rank": 945,
          "turkishWord": "koku",
          "englishWord": "smell"
        },
        {
          "rank": 946,
          "turkishWord": "vadi",
          "englishWord": "valley"
        },
        {
          "rank": 947,
          "turkishWord": "ne",
          "englishWord": "nor"
        },
        {
          "rank": 948,
          "turkishWord": "çift",
          "englishWord": "double"
        },
        {
          "rank": 949,
          "turkishWord": "koltuk",
          "englishWord": "seat"
        },
        {
          "rank": 950,
          "turkishWord": "devam",
          "englishWord": "continue"
        },
        {
          "rank": 951,
          "turkishWord": "bloğu",
          "englishWord": "block"
        },
        {
          "rank": 952,
          "turkishWord": "grafiği",
          "englishWord": "chart"
        },
        {
          "rank": 953,
          "turkishWord": "şapka",
          "englishWord": "hat"
        },
        {
          "rank": 954,
          "turkishWord": "satmak",
          "englishWord": "sell"
        },
        {
          "rank": 955,
          "turkishWord": "başarı",
          "englishWord": "success"
        },
        {
          "rank": 956,
          "turkishWord": "şirket",
          "englishWord": "company"
        },
        {
          "rank": 957,
          "turkishWord": "çıkarmak",
          "englishWord": "subtract"
        },
        {
          "rank": 958,
          "turkishWord": "olay",
          "englishWord": "event"
        },
        {
          "rank": 959,
          "turkishWord": "özellikle",
          "englishWord": "particular"
        },
        {
          "rank": 960,
          "turkishWord": "anlaşma",
          "englishWord": "deal"
        },
        {
          "rank": 961,
          "turkishWord": "yüzmek",
          "englishWord": "swim"
        },
        {
          "rank": 962,
          "turkishWord": "vadeli",
          "englishWord": "term"
        },
        {
          "rank": 963,
          "turkishWord": "karşısında",
          "englishWord": "opposite"
        },
        {
          "rank": 964,
          "turkishWord": "karısı",
          "englishWord": "wife"
        },
        {
          "rank": 965,
          "turkishWord": "ayakkabı",
          "englishWord": "shoe"
        },
        {
          "rank": 966,
          "turkishWord": "omuz",
          "englishWord": "shoulder"
        },
        {
          "rank": 967,
          "turkishWord": "yaymak",
          "englishWord": "spread"
        },
        {
          "rank": 968,
          "turkishWord": "düzenlemek",
          "englishWord": "arrange"
        },
        {
          "rank": 969,
          "turkishWord": "kamp",
          "englishWord": "camp"
        },
        {
          "rank": 970,
          "turkishWord": "icat",
          "englishWord": "invent"
        },
        {
          "rank": 971,
          "turkishWord": "pamuk",
          "englishWord": "cotton"
        },
        {
          "rank": 972,
          "turkishWord": "doğmuş",
          "englishWord": "born"
        },
        {
          "rank": 973,
          "turkishWord": "belirlemek",
          "englishWord": "determine"
        },
        {
          "rank": 974,
          "turkishWord": "kuart",
          "englishWord": "quart"
        },
        {
          "rank": 975,
          "turkishWord": "dokuz",
          "englishWord": "nine"
        },
        {
          "rank": 976,
          "turkishWord": "kamyon",
          "englishWord": "truck"
        },
        {
          "rank": 977,
          "turkishWord": "gürültü",
          "englishWord": "noise"
        },
        {
          "rank": 978,
          "turkishWord": "seviyesi",
          "englishWord": "level"
        },
        {
          "rank": 979,
          "turkishWord": "şans",
          "englishWord": "chance"
        },
        {
          "rank": 980,
          "turkishWord": "toplamak",
          "englishWord": "gather"
        },
        {
          "rank": 981,
          "turkishWord": "dükkan",
          "englishWord": "shop"
        },
        {
          "rank": 982,
          "turkishWord": "streç",
          "englishWord": "stretch"
        },
        {
          "rank": 983,
          "turkishWord": "atmak",
          "englishWord": "throw"
        },
        {
          "rank": 984,
          "turkishWord": "parlaklık",
          "englishWord": "shine"
        },
        {
          "rank": 985,
          "turkishWord": "mülkiyet",
          "englishWord": "property"
        },
        {
          "rank": 986,
          "turkishWord": "sütun",
          "englishWord": "column"
        },
        {
          "rank": 987,
          "turkishWord": "molekülü",
          "englishWord": "molecule"
        },
        {
          "rank": 988,
          "turkishWord": "seçin",
          "englishWord": "select"
        },
        {
          "rank": 989,
          "turkishWord": "yanlış",
          "englishWord": "wrong"
        },
        {
          "rank": 990,
          "turkishWord": "gri",
          "englishWord": "gray"
        },
        {
          "rank": 991,
          "turkishWord": "tekrar",
          "englishWord": "repeat"
        },
        {
          "rank": 992,
          "turkishWord": "gerektirir",
          "englishWord": "require"
        },
        {
          "rank": 993,
          "turkishWord": "geniş",
          "englishWord": "broad"
        },
        {
          "rank": 994,
          "turkishWord": "hazırlamak",
          "englishWord": "prepare"
        },
        {
          "rank": 995,
          "turkishWord": "tuz",
          "englishWord": "salt"
        },
        {
          "rank": 996,
          "turkishWord": "burun",
          "englishWord": "nose"
        },
        {
          "rank": 997,
          "turkishWord": "çoğul",
          "englishWord": "plural"
        },
        {
          "rank": 998,
          "turkishWord": "öfke",
          "englishWord": "anger"
        },
        {
          "rank": 999,
          "turkishWord": "iddia",
          "englishWord": "claim"
        },
        {
          "rank": 1000,
          "turkishWord": "kıta",
          "englishWord": "continent"
        }
      ]

      export default wordse